// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__GuL5p","imageUploader":"EGiftCard_imageUploader__1CpqF"};